/**
 * Offline ID strategy (ADR-004): the device mints UUID v4 primary keys that
 * are final - the server accepts them verbatim at sync, so there is never a
 * temp-id remap. `crypto.randomUUID` exists in Node ≥ 19 and in every WebView
 * this app targets.
 */
export const newId = () => globalThis.crypto.randomUUID();
const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
export const isUuid = (value) => UUID_RE.test(value);
//# sourceMappingURL=ids.js.map